<template>
  <div id="conclusion">
    <div class="view">
      <ul class="scene">
        <!-- Ground -->
        <li class="layer scene__layer scene__layer--ground" data-depth="-0.2">
          <div class="scene__illus scene__illus--ground"></div>
        </li>

        <!-- Foreground (people) -->
        <li class="layer scene__layer scene__layer--foreground" data-depth="0.0">
        </li>

        <!-- Middleground (buildings) -->
        <li class="layer scene__layer scene__layer--midground" data-depth="0.2">
        </li>

        <!-- Background (landscape) -->
        <li class="layer scene__layer scene__layer--background" data-depth="1">
          <img class="scene__illus scene__illus--background" src="../../assets/svg/start/background.svg" alt="">
        </li>

        <!-- Sky  -->
        <li class="scene__sky">
          <img class="scene__cloud scene__cloud--first" src="../../assets/svg/scene__clouds-1.svg" alt="">
          <img class="scene__cloud scene__cloud--second" src="../../assets/svg/scene__clouds-1.svg" alt="">
          <img class="scene__cloud scene__cloud--third" src="../../assets/svg/scene__clouds-2.svg" alt="">
          <img class="scene__cloud scene__cloud--fourth" src="../../assets/svg/scene__clouds-1.svg" alt="">
          <img class="scene__sun" src="../../assets/svg/scene__sun.svg" alt="">
        </li>
      </ul>
    </div>

    <div class="finish-continue" v-if="!showResults">
      <div class="finish-continue__frame">

        <div class="finish-continue__block">
          <div class="finish-continue__block-wrap">
            <h2>Continue your progress</h2>
            <p>You haven't finished answering all of the questions</p>
            <p><router-link :to="{ name: 'intro' }" class="finish__button">Return to the quiz</router-link></p>
          </div>
        </div>

      </div>
    </div>

    <div class="finish-results" v-if="showResults">
      <div class="finish-results__frame">

        <div class="finish-results__message">
          <div class="finish-results__message-wrap">
            <h1>Thank you for taking on the Eco-Schools Quiz!</h1>
            <p>Each question was designed to get you thinking about simple actions that can be taken to help your school become more eco-friendly. No matter what your score, we hope you feel energised and inspired! And remember, you and your school have the power to make changes that will benefit everyone on our planet.</p>
          </div>
        </div>

        <div class="finish-results__block finish-results__block--half finish-results__block--score">
          <div class="finish-results__block-wrap">
            <h2>Your Score</h2>
            <p class="finish-results__score">{{score}}%</p>
            <p>You answered {{right}}/{{total}}<br> questions correctly</p>
          </div>
        </div>

        <div class="finish-results__block finish-results__block--half finish-results__block--share">
          <div class="finish-results__block-wrap">
            <h2>Share the quiz</h2>
            <ul class="social-media">
              <li class="social-media__item social-media__item--facebook">
                <a href="https://www.facebook.com/share.php" target="_blank" rel="noopener noreferrer">Facebook</a>
              </li>
              <li class="social-media__item social-media__item--twitter">
                <a href="https://twitter.com/intent/tweet" target="_blank" rel="noopener noreferrer">Twitter</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="finish-results__frame finish-results__return">
        <div class="finish-results__block">
          <div class="finish-results__block-wrap">
            <h2>Become an Eco-School!</h2>
            <p>Discover how you can make a difference today.</p>
            <p><a href="https://members.eco-schools.org.uk/signup" target="_blank" rel="noopener noreferrer">Register</a></p>
            <p><router-link :to="{ name: 'intro' }" class="finish-results__return--button">Return to the quiz</router-link></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ParallaxClass } from '../../classes/ParallaxClass'
  import { Clouds } from '../../classes/Clouds'
  import { Animations } from '../../classes/Animations'
  import { Scores } from '../../classes/Scores'

  const parallax = new ParallaxClass()
  const clouds = new Clouds([
    [ '.scene__cloud--first', 130 ],
    [ '.scene__cloud--second', 90 ],
    [ '.scene__cloud--third', 80 ],
    [ '.scene__cloud--fourth', 110 ]
  ])
  const animations = new Animations()
  const scores = new Scores()

  export default {
    name: 'view-start',
    data () {
      return {
        right: '0',
        wrong: '0',
        total: '0',
        score: '0',
        showResults: false
      }
    },
    methods: {
      checkResults () {
        console.log(scores)
        if (scores.progress === scores.total) {
          this.showResults = true
          this.right = scores.right
          this.wrong = scores.wrong
          this.total = scores.total
          this.score = scores.score
        } else {
          this.showResults = false
          this.right = 0
          this.wrong = 0
          this.total = 0
          this.score = 0
        }
      }
    },
    activated () {
      this.$nextTick(() => {
        setTimeout(() => {
          parallax.addToPage(this.$route.name)
          clouds.animate(this.$route.name)
          this.checkResults()
        }, 500)
      })
    },
    deactivated () {
      parallax.disable()
      clouds.disable()
      animations.disable()
    }
  }
</script>



// WEBPACK FOOTER //
// Conclusion.vue?18fb8a29